import React, { useEffect, useRef } from 'react';
import { useTranslation } from '../contexts/TranslationContext';
import { FILE_BASE_URL } from "../config/env";
import './PhotoModal.scss';

const PhotoModal = ({ photo, onClose }) => {
    const { t } = useTranslation();
    const modalRef = useRef(null);
    const filePath = FILE_BASE_URL;

    const handleClickOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            onClose();
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="photo-modal">
            <div ref={modalRef} className="photo-modal-content">
                <img
                    src={photo}
                    alt="photo"
                    className={`modal-photo`}
                />
            </div>
            <button className="close-button" onClick={onClose}>Закрыть</button>
        </div>
    );
};

export default PhotoModal;
